import React from 'react'

const corporate = () => {
  return (
    <div>
     <div className="Copor">
    <p> • Employee Assistance Programs (EAPs) - confidential counselling for staff and families<br></br>
      • Workplace Wellness Programs - stress management, burnout prevention, mental health awareness<br></br>
        • Conflict Resolution & Mediation - team harmony and dispute resolution <br></br>
        • Trauma & Critical Incident Debriefing - after workplace accidents, robberies, or violence <br></br>
        • Substance Abuse Prevention & Intervention
        • Professional Development Workshops - leadership, resilience, diversity & inclusion<br></br>
  </p>

     </div>
    </div>
  )
}

export default corporate